import React, { useEffect } from "react";
import moment from "moment";
import PriceDetailsTable from "./PriceDetailsTable";

function PriceListContent({ data }) {
  useEffect(() => {}, [data]);

  const manageSalesStatus = (status) => {
    let baseClass = "px-3 py-1 rounded-full text-sm font-semibold";

    switch (status) {
      case "Draft":
        return `${baseClass} bg-gray-300 text-gray-800`;
      case "Active":
        return `${baseClass} bg-green-100 text-green-700`;
      case "Pending for Approval":
        return `${baseClass} bg-yellow-100 text-yellow-800`;
      case "Fulfilled":
        return `${baseClass} bg-blue-100 text-blue-800`;
      case "Rejected":
        return `${baseClass} bg-red-100 text-red-700`;
      case "Confirmed":
        return `${baseClass} bg-purple-100 text-purple-800`;
      case "Partially Billed":
        return `${baseClass} bg-indigo-100 text-indigo-700`;
      default:
        return `${baseClass} bg-gray-200 text-gray-600`;
    }
  };

  return (
    <section className="w-full max-w-6xl mx-auto p-4 bg-white border rounded-md shadow-sm text-gray-700">
      <h2 className="text-xl font-bold text-center mb-4 border-b pb-2">
        Product Item Information
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Left Column */}
        <div className="space-y-2 text-sm">
          <div>
            <span className="font-semibold">Corporate Name:</span>{" "}
            <span className="text-primary font-medium">
              {data?.Corporate_Name}
            </span>
          </div>
          <div>
            <span className="font-semibold">Contact Person:</span>{" "}
            <span className="text-primary">
              {data?.Corporate_Contact_Person}
            </span>
          </div>
          <div>
            <span className="font-semibold">Contact Number:</span>{" "}
            <span className="text-primary">
              {data?.Corporate_Contact_Person_Mobile}
            </span>
          </div>
        </div>

        {/* Right Column */}
        <div className="space-y-2 text-sm">
          <div>
            <span className="font-semibold">Email:</span>{" "}
            <span className="text-primary">
              {data?.Corporate_Email_Address}
            </span>
          </div>
          <div>
            <span className="font-semibold">Address:</span>{" "}
            <span className="text-primary">
              {data?.Corporate_Adddress}, {data?.Area_Name}, {data?.City_Name},{" "}
              {data?.Country_Name}
            </span>
          </div>
          <div>
            <span className="font-semibold">Agreement Date:</span>{" "}
            <span className="text-primary">
              {moment(data?.Agreement_Date).format("MMMM Do YYYY")}
            </span>
          </div>
        </div>
      </div>

      {/* Optional status display */}
      {data?.Status && (
        <div className="mt-6 text-center">
          <span className={manageSalesStatus(data?.Status)}>
            {data?.Status}
          </span>
        </div>
      )}
    </section>
  );
}

export default PriceListContent;
